"use client";

import { motion } from "framer-motion";
import { Check, X } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const features = [
  "Code Editing",
  "Visual Editing",
  "AI Editing",
  "Live Preview",
  "Import any Web Project (HTML,CSS,JS)",
  "GitHub Workflow (Branches)",
  "Framework-Free / SEO-Ready",
  "AI Edits that Don't Break Code",

];

const competitors = [
  {
    name: "Raffaello",
    features: [true, true, true, true, true, true, true, true],
  },
  {
    name: "Lovable",
    features: [false, false, true, true, false, false, false, false],
  },
  {
    name: "Bolt",
    features: [false, false, true, true, false, true, false, false,],
  },
  {
    name: "V0",
    features: [false, false, true, true, false, true, false,false],
  },
  {
    name: "Macaly",
    features: [false, false, true, true, false, false, false, false],
  },
  {
    name: "Cursor",
    features: [true, false, true, false, true, true, false, false],
  },
  {
    name: "Windsurf",
    features: [true, false, true, false, true, true, false, false],
  },
];

export function RaffaelloComparisonTable() {
  return (
    <section className="py-16 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-3">
            What Makes Raffaello Different?
          </h2>
        </div>

        <motion.div
          className="overflow-x-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <Table className="w-full border-collapse">
            <TableHeader>
              <TableRow className="">
                <TableHead className="w-1/4 py-4 px-6 text-left font-semibold">
                  Feature
                </TableHead>
                {competitors.map((competitor, index) => (
                  <TableHead
                    key={index}
                    className={`py-4 px-6 text-center font-semibold ${competitor.name === "Raffaello" ? "bg-slate-800 text-white" : ""}`}
                  >
                    {competitor.name}
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {features.map((feature, featureIndex) => (
                <TableRow
                  key={featureIndex}
                  className={
                    featureIndex % 2 === 0 ? "bg-card" : "bg-slate-800-50"
                  }
                >
                  <TableCell className="py-4 px-6 border-t border-gray-200">
                    {feature}
                  </TableCell>
                  {competitors.map((competitor, competitorIndex) => (
                    <TableCell
                      key={competitorIndex}
                      className={`py-4 px-6 text-center border-t border-gray-200 ${competitor.name === "Raffaello" ? "bg-slate-500" : ""}`}
                    >
                      {competitor.features[featureIndex] ? (
                        <Check className="mx-auto h-5 w-5 text-green-500" />
                      ) : (
                        <X className="mx-auto h-5 w-5 text-red-500" />
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </motion.div>
      </div>
    </section>
  );
}
